import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { Box, ButtonBase, Theme } from '@mui/material';
import classNames from 'classnames';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme: Theme) => ({
  mobileMultiplierSelector: {
    borderRadius: theme.shape.borderRadius,
    position: 'relative',
    width: 91,
    height: 38,
    border: `1px solid ${theme.palette.custom.border.primary}`,
  },

  addOrSubtract: {
    padding: '12px 2px',
    borderRadius: '4px',
    height: '100%',
  },
}));

interface QuantityInputProps {
  disabled?: boolean;
  onIncrement: () => void;
  onDecrement: () => void;
  Input: React.ReactNode;
  className?: string;
}

export const QuantityControlInput: React.FC<QuantityInputProps> = ({
  disabled = false,
  onIncrement,
  onDecrement,
  className,
  Input,
}) => {
  const { classes } = useStyles();

  return (
    <Box
      className={classNames(className, classes.mobileMultiplierSelector)}
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      }}
    >
      <ButtonBase
        tabIndex={-1}
        aria-label="remove item"
        disabled={disabled}
        color={disabled ? 'default' : 'primary'}
        className={classes.addOrSubtract}
        onClick={onDecrement}
        onMouseDown={(event) => event.preventDefault()}
      >
        <RemoveIcon fontSize="small" color={disabled ? 'disabled' : 'primary'} />
      </ButtonBase>
      {Input}
      <ButtonBase
        tabIndex={-1}
        aria-label="add item"
        disabled={disabled}
        color={disabled ? 'default' : 'primary'}
        className={classes.addOrSubtract}
        onClick={onIncrement}
        onMouseDown={(event) => event.preventDefault()}
      >
        <AddIcon fontSize="small" color={disabled ? 'disabled' : 'primary'} />
      </ButtonBase>
    </Box>
  );
};
